import { useTelemetry } from '@iamexperiences/ecos-telemetry';
import { useQuery } from 'react-query';

import { HttpRequestError } from '../../shared/HttpRequestError';
import { settingsManager } from '../../shared/settings';
import { getRequestBody } from '../utilities/getRequestBody';

export const useGetTenantBannerLogo = () => {
  const telemetry = useTelemetry();
  // This hook is only used in unauthenticated flow and should always use access token from the request body
  const { accessToken } = getRequestBody();

  const query = useQuery({
    queryKey: ['tenantbannerlogo'],
    queryFn: async () => {
      const url = `${settingsManager.get('myAccountBackendUrl')}/api/termsofuse/tenantbannerlogo`;
      const token = accessToken;
      const response = await fetch(url, {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });

      if (!response.ok) {
        const error = new HttpRequestError(response.status, response.statusText);
        telemetry.error('Error getting tenantdisplayname', error);

        throw error;
      }

      const data = await response.text();

      return data;
    },
    staleTime: Infinity,
  });

  return query;
};
